import React, { Component } from 'react';
import { connect } from 'react-redux';
import { alertSuccess } from '../actions/alertActions';
import { api } from '../services/rest';
import { withRouter } from 'react-router-dom';
import Menu from './Menu';

class ProjectSettings extends Component {
    constructor(props) {
        super(props);
        this.onSubmit = this.onSubmit.bind(this);
        this.ftpUser = React.createRef();
        this.ftpPassword = React.createRef();
        this.ftpHost = React.createRef();
        this.ftpRemoteFolder = React.createRef();
        this.useGulp = React.createRef();
        this.buildName = React.createRef();
        this.buildDescription = React.createRef();
        this.buildKeywords = React.createRef();
        this.perPage = React.createRef();
        this.closeModal = this.closeModal.bind(this);
        this.state = {
            settings: {
                gulp: {
                    ftpUser: "",
                    ftpPassword: "",
                    ftpHost: "",
                    ftpRemoteFolder: "",
                    useGulp: false
                },
                buildSSG: {
                    name: "",
                    description: "",
                    keywords: "",
                    perPage: false
                }
            },
            saved:false
        }

        this.handleCheckChange = this.handleCheckChange.bind(this);
        this.handleGulpCheckChange = this.handleGulpCheckChange.bind(this);
        this.handleOnDescriptionChange = this.handleOnDescriptionChange.bind(this);
        this.handleOnKeywordsChange = this.handleOnKeywordsChange.bind(this);
    }

    componentDidMount() {
        api.get(`/${this.props.match.params.client}/${this.props.match.params.project}/ProjectSettings/Get`)
            .then(res => this.setState({ settings: res.data }));
    }

    onSubmit() {
        
        var createString = "gulpData[" + this.refs.ftpUser.value + "??" + this.refs.ftpPassword.value + "??" + this.refs.ftpHost.value + "??" + this.refs.ftpRemoteFolder.value + "??" + this.refs.useGulp.checked.toString() + "]::buildData[" + this.refs.buildName.value + "??" + this.refs.buildDescription.value + "??" + this.refs.buildKeywords.value + "??" + this.refs.perPage.checked.toString() + "]";

        fetch(`/api/${this.props.match.params.client}/${this.props.match.params.project}/ProjectSettings/`, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                'Access-Control-Allow-Origin': '*'
            },
            body: JSON.stringify(createString)
        })
            .then(this.resetForm());
    }

    handleOnDescriptionChange(event) {
        var settings = this.state.settings;
        settings.buildSSG.description = event.target.value;
        this.setState({
            settings: settings
        })
    }

    handleOnKeywordsChange(event) {
        var settings = this.state.settings;
        settings.buildSSG.keywords = event.target.value;
        this.setState({
            settings: settings
        })
    }

    handleCheckChange(event) {
        var settings = this.state.settings;
        settings.buildSSG.perPage = event.target.checked;
        this.setState({
            settings: settings
        })
    }

    handleGulpCheckChange(event) {
        var settings = this.state.settings;
        settings.gulp.useGulp = event.target.checked;
        this.setState({
            settings: settings
        })
    }

    closeModal() {
        this.setState({ saved: false });
    }

    resetForm() {
        api.get(`/${this.props.match.params.client}/${this.props.match.params.project}/ProjectSettings/Get`)
            .then(res => this.setState({ settings: res.data }));
        this.setState({ saved: true });
    }

    render() {
        //console.log(this.state.settings);
        return (
            <div>
                <style dangerouslySetInnerHTML={{
                    __html: `
                    .hidden{
                    display:none;
                    }
                    .modal{
                    border: 1px solid #ddd;
                    background:#fff;
                    border-radius: 5px;
                    display:block;
                    position:relative;
                    margin-left:auto;
                    margin-right:auto;
                    top:40%;
                    width: 250px;
                    height: 100px;
                    padding:5px;
                    text-align:center;
                    }`}} />
                <Menu className="sidebar sidebar-inverse pr-0 pl-0" client={this.props.match.params.client} project={this.props.match.params.project} />
                <div className="sidebar-offset container-fluid">
                    <h1>Project Settings</h1>
                    <form>
                        <h3>Configuration: </h3>
                        <br /><br />
                        <div style={{ width: 35 + '%', textAlign: 'right' }}>
                            <label>FTP User: </label><input ref="ftpUser" id="ftpUser" style={{ width: 80 + '%', marginLeft: '10px' }} defaultValue={this.state.settings["gulp"].ftpUser} /><br /><br />
                            <label>FTP Password: </label><input ref="ftpPassword" id="ftpPassword" type="password" style={{ width: 80 + '%', marginLeft: '10px' }} defaultValue={this.state.settings["gulp"].ftpPassword} /><br /><br />
                            <label>FTP Host: </label><input ref="ftpHost" id="ftpHost" style={{ width: 80 + '%', marginLeft: '10px' }} defaultValue={this.state.settings["gulp"].ftpHost} /><br /><br />
                            <label>Remote Folder: </label><input ref="ftpRemoteFolder" id="ftpRemoteFolder" style={{ width: 80 + '%', marginLeft: '10px' }} defaultValue={this.state.settings["gulp"].ftpRemoteFolder} /><br />
                            <label>Use Gulp: </label><input ref="useGulp" type="checkbox" id="useGulp" style={{ width: 80 + '%', marginLeft: '10px' }}checked={this.state.settings["gulp"].useGulp} onChange={(event) => this.handleGulpCheckChange(event)} /><br />
                        </div><br />
                        <h3>Site Meta: </h3>
                        <br /><br />
                        <div style={{ width: 35 + '%', textAlign: 'right' }}>
                            <label>Per-Page Tags: </label><input type="checkbox" ref="perPage" id="perPage" style={{ width: 80 + '%', marginLeft: '10px' }} checked={this.state.settings["buildSSG"].perPage} onChange={(event) => this.handleCheckChange(event)} /><br /><br />
                            <label>Name: </label><input ref="buildName" id="buildName" style={{ width: 80 + '%', marginLeft: '10px' }} defaultValue={this.state.settings["buildSSG"].name} /><br /><br />
                            <label>Description: </label><textarea ref="buildDescription" id="buildDescription" style={{ width: 80 + '%', marginLeft: '10px' }} value={this.state.settings["buildSSG"].description} onChange={(event) => this.handleOnDescriptionChange(event)} /><br /><br />
                            <label>Keywords: </label><textarea ref="buildKeywords" id="buildKeywords" style={{ width: 80 + '%', marginLeft: '10px' }} value={this.state.settings["buildSSG"].keywords} onChange={(event) => this.handleOnKeywordsChange(event)} /><br /><br />
                        </div><br />
                        <input type="button" value="Save Settings" onClick={this.onSubmit} />
                    </form>
                    <div className={this.state.saved ? 'modal center-block' : 'modal hidden'}>
                        <h2>Save Successful</h2>
                        <input type="button" value="Close" onClick={this.closeModal} />
                    </div>
                </div>
            </div>
        )
    }
}

const ProjSettings = withRouter(ProjectSettings);

function ResourceUploader(props) {
    //const {
    //    id,
    //    value,
    //    disabled,
    //    readonly,
    //    autofocus,
    //} = props;

    return (
        <ProjSettings {...props} />
    );
}

export default connect(null, { alertSuccess })(ResourceUploader);